import { render, staticRenderFns } from "./TenderListFooterCell.vue?vue&type=template&id=0d38034c&"
import script from "./TenderListFooterCell.vue?vue&type=script&lang=js&"
export * from "./TenderListFooterCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports